package one.healthium.firebase.di

import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseApp
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.functions.functions
import dev.gitlive.firebase.initialize
import dev.gitlive.firebase.remoteconfig.remoteConfig
import one.primehealth.app.BaseAppConfig
import org.koin.core.module.Module
import org.koin.dsl.module

actual fun firebasePlatformModule(): Module = module {
    single<FirebaseApp> {
        val appConfig: BaseAppConfig = get()
        Firebase.initialize(
            null, FirebaseOptions(
                apiKey = appConfig.firebaseApp.apiKey,
                authDomain = appConfig.firebaseApp.authDomain,
                projectId = appConfig.firebaseApp.projectId,
                storageBucket = appConfig.firebaseApp.storageBucket,
                applicationId = appConfig.firebaseApp.applicationId,
            )
        )
    }
    single { Firebase.auth(get()) }
    single { Firebase.functions(get<FirebaseApp>()) }
    single { Firebase.remoteConfig(get<FirebaseApp>()) }
}